import React from "react";
import { THIS_YEAR } from "utils/consts";
import { getCookie } from "utils/getCookie";
import defaultAvatarImg from "assets/img/default-avatar.png";
import { useTranslation } from "react-i18next";
import keyword01 from "assets/img/keyword/1.png";
import keyword02 from "assets/img/keyword/2.png";
import keyword03 from "assets/img/keyword/3.png";
import keyword04 from "assets/img/keyword/4.png";
import keyword05 from "assets/img/keyword/5.png";
import keyword06 from "assets/img/keyword/6.png";
import keyword07 from "assets/img/keyword/7.png";
import keyword08 from "assets/img/keyword/8.png";
import keyword09 from "assets/img/keyword/9.png";
import keyword10 from "assets/img/keyword/10.png";
import keyword11 from "assets/img/keyword/11.png";
import keyword12 from "assets/img/keyword/12.png";
import keyword13 from "assets/img/keyword/13.png";
import keyword14 from "assets/img/keyword/14.png";
import keyword15 from "assets/img/keyword/15.png";
import keyword16 from "assets/img/keyword/16.png";
import keyword17 from "assets/img/keyword/17.png";
import keyword18 from "assets/img/keyword/18.png";
import keyword19 from "assets/img/keyword/19.png";
import keyword20 from "assets/img/keyword/20.png";
import gateioLogo from "assets/img/keyword/gateio_logo.png";
import { removePercent } from "utils/handle_data";
import { conversionUnit, isZero } from "utils/tool";
import { WhiteUpIcon } from "static/svg";

const LabelValueItem = ({ label, value, unit, percentage }) => {
  let reg = /\%$/;
  return (
    <div className="label-value-item">
      <div
        className="label"
        dangerouslySetInnerHTML={{
          __html: label,
        }}
      ></div>
      {value ? (
        <div className="value">
          <span className="hiddenHtml">{conversionUnit(value)}</span>
          <span className="unit">{unit}</span>
        </div>
      ) : (
        ""
      )}
      {percentage ? (
        <div className="percentage">
          {removePercent(percentage) > 0 ? (
            <WhiteUpIcon type="up" />
          ) : (
            <WhiteUpIcon type="down" />
          )}
          <span className="hiddenHtml">
            {reg.test(percentage)
              ? percentage.replace("-", "")
              : percentage.replace("-", "") + "%"}
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export const KeyWordComponent = ({
  dataSoure,
  isInvitePage,
  annualData = {},
}) => {
  const { i18n } = useTranslation();
  const { keywords = [], personality } = dataSoure;
  // 优先获取邀请人的信息
  const [avatar, nickname] = [
    getCookie("avatar") || defaultAvatarImg,
    getCookie("nickname") || "Gater",
  ];
  const t = window.t;
  const { title, id } = personality;
  const { language } = i18n;

  const isEasternLang =
    language === "zh" || language === "tw" || language === "ja";
  const images = [
    keyword01,
    keyword02,
    keyword03,
    keyword04,
    keyword05,
    keyword06,
    keyword07,
    keyword08,
    keyword09,
    keyword10,
    keyword11,
    keyword12,
    keyword13,
    keyword14,
    keyword15,
    keyword16,
    keyword17,
    keyword18,
    keyword19,
    keyword20,
  ];

  return (
    <div className="centerner keyword-share-container">
      <img className="bgimg" src={images[id - 1]} alt="" />
      {!isInvitePage && (
        <div className="keyword-share-logo">
          <img src={gateioLogo} alt="" />
        </div>
      )}
      <div className="absolute-wraper">
        <div className="centernerTitle" style={{ margin: 0 }}></div>
        {!isInvitePage && (
          <div className="avatar-wraper">
            <div className="avatar-box">
              <div className="avatar">
                <img className="keyword-avatar-img" src={avatar} alt="" />
              </div>
              <span>{nickname}</span>
            </div>
          </div>
        )}

        <div className="keyword-title-wraper">
          <LabelValueItem
            label={t("Annual.Trading.Volume")}
            value={annualData?.year_transaction}
            unit="USDT"
            percentage={annualData?.year_transaction_percentage}
          />
          <LabelValueItem
            label={t("Annual.Total.Return")}
            value={annualData?.total_profit}
            unit="USDT"
            percentage={annualData?.total_profit_yield}
          />
          <LabelValueItem
            label={t("Surpassing.Gate.users", {
              AnnualReturn: `<span class="${
                language === "zh" || language === "tw"
                  ? "inline-block"
                  : "annual-return-label"
              }">${t("Annual.Return")}</span>`,
              percentage: annualData?.profit_exceeded_users || "0%",
            })}
          />
        </div>
        <div className="main">
          <div className="keyword-bottom-container">
            <div className="keyword-title">
              <span>
                {t("year.Narrative", {
                  thisYear: THIS_YEAR,
                })}
              </span>
            </div>
            <div className={`keyword-subtitle ${isEasternLang ? "big" : ""}`}>
              #{t(title)}
            </div>
            <div className={`keyWords-list ${isEasternLang ? "scale" : ""}`}>
              <div className="under-keyword-list">
                {keywords.map((item, index) => {
                  return (
                    <div className="keyword-box" key={item}>
                      <span>{item}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
